import { Result } from 'antd';
import styled from 'styled-components';

export default styled(Result)`
	// Add your styles here
`;
